import { render, staticRenderFns } from "./Php.vue?vue&type=template&id=5c45abb6&scoped=true&"
import script from "./Php.vue?vue&type=script&lang=js&"
export * from "./Php.vue?vue&type=script&lang=js&"
import style0 from "./Php.vue?vue&type=style&index=0&id=5c45abb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c45abb6",
  null
  
)

export default component.exports